module.exports = __webpack_public_path__ + "static/Ahold-6a52a9c0b6eb47149fe45ee6e7a71636.jpg";